// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarArquivosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/arquivos/migrar-lote.
 *
 * O fechamento de UM LOTE — não da franquia. Esta é a única etapa da migração
 * cuja porta de carga NÃO termina o trabalho: ~23.500 arquivos e ~27 GB por
 * franquia não cabem numa requisição, então quem chama repete enquanto
 * `tem_mais` for verdadeiro.
 *
 * `n_migrados + n_pulados + n_falhos == n_lidos`, sempre.
 *
 * ATENÇÃO AO PAR `restantes`/`tem_mais`: os dois saem do MESMO recorte, e é ele
 * que encerra o laço da tela. `tem_mais` deriva de `restantes`, nunca de "li
 * alguma coisa" — um lote que consome exatamente o que faltava já devolve
 * `tem_mais=false`, sem rodada vazia.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarArquivosResponseDados {
run_id: number
n_lidos: number
n_migrados: number
n_pulados: number
n_falhos: number
restantes: number
tem_mais: boolean
}

export type Migration_MigrarArquivosResponse = ApiResponse<Migration_MigrarArquivosResponseDados>;

registerResponseContract('Migration_MigrarArquivosResponse', {
  run_id:     { type: 'number',  required: true },
  n_lidos:    { type: 'number',  required: true },
  n_migrados: { type: 'number',  required: true },
  n_pulados:  { type: 'number',  required: true },
  n_falhos:   { type: 'number',  required: true },
  restantes:  { type: 'number',  required: true },
  tem_mais:   { type: 'boolean', required: true },
})
